import {createContext} from "react";

export interface ICheckboxContext {
	isFocused: boolean;
	isKeyboardFocused: boolean;
	isSelected: boolean;
	isPressed: boolean;
	isDisabled: boolean;
}

export const CheckboxContext = createContext<ICheckboxContext>({
	isFocused: false,
	isKeyboardFocused: false,
	isSelected: false,
	isPressed: false,
	isDisabled: false,
});
